import React from 'react';
import classNames from 'classnames';

const CountDown = ({ resendCode, countdown }) => {
  const deliverSMSCode = () => {
    if (countdown > 0) return;
    resendCode({ isNotAuto: true });
  };
  return (
    <div
      className={classNames('countdown', {
        disabled: countdown,
      })}
      onClick={deliverSMSCode}
    >
      {countdown ? `${countdown}秒后可重新发送` : '点击获取验证码'}
    </div>
  );
};

export default CountDown;
